import loop54 from '~/lib/api/loop54';
import { Loop54Types } from '~/lib/data-contract';
import loop54Errors from '~/services/loop54/errors';
import { getUrl } from '~/services/loop54/utils';
import { EntitiesRequest } from '../types';

export default function getEntities(
    signal: AbortSignal | undefined,
    params: EntitiesRequest | undefined,
) {
    if (!params) {
        return Promise.reject(new Error(loop54Errors.missingParams.message));
    }

    return loop54
        .post(getUrl('/getEntities'), {
            json: params,
            signal,
        })
        .json<Loop54Types.GetEntitiesResponse>();
}
